import React from "react";
import { CardLayout } from "components/cardLayout";
import { MoveInfo } from "components/moveInfo";

export interface InfoCardProps {
    valuationText?: any;
    estimateText?: any;
    title1?: any;
    content1?: any;
    title2?: any;
    content2?: any;
}
 
export interface InfoCardState {
    
}
 
class InfoCard extends React.Component<InfoCardProps, InfoCardState> {
    constructor(props: InfoCardProps) {
        super(props);
        this.state = {  };
    }
    render() { 
        return ( 
            <CardLayout style={{padding:"0em 1em 0em 1em"}}>
                <MoveInfo
                valuationText={this.props.valuationText}
                estimateText={this.props.estimateText}
                title1={this.props.title1}
                content1={this.props.content1}
                title2={this.props.title2}
                content2={this.props.content2}
                />
            </CardLayout>
         );
    }
}
 
export default InfoCard;